import { BACKGROUND_COLOR, ICON_COLOR } from '@common/themes/header';

import Icon from '@common/interfaces/icon.interface';

export const USER_SETTINGS_PATH = 'user-settings';

export const ACCOUNT_DETAILS_PANEL_TITLE = 'Account details';
export const ACCOUNT_DETAILS_PANEL_ICON: Icon = {
    backgroundColor: BACKGROUND_COLOR,
    color: ICON_COLOR,
    class: 'user',
    isText: true,
};
export const CHANGE_PASSWORD_PANEL_TITLE = 'New password';
export const CHANGE_PASSWORD_PANEL_ICON: Icon = {
    backgroundColor: BACKGROUND_COLOR,
    color: ICON_COLOR,
    class: 'password',
    width: '38',
    isSvg: true,
};

export const CHANGE_PASSWORD_SUCCESS_MESSAGE = 'Your password was updated successfully.';

export const BACK_BUTTON_TEXT = 'Back to home';
